<ng-container [formGroup]="form">
  <app-header title="Manage Events"></app-header>
  <ng-container *ngIf="sponsorMode === 'list' && slideMode === 'list' && configMode === 'list' && eventPageSlideMode === 'list'">
    <div class="container pt-5 mt-5">
      <div class="d-flex justify-content-between mb-3">
        <div class="campaign__title">Virtual Event</div>
        <div class="campaign__action-list d-flex align-items-center">
            <button class="btn btn--paybee btn--outline-transparent mr-2" (click)="onCancel()">Cancel</button>
            <button [ngClass]="imageService.loadingClasses()" class="btn btn--paybee btn--success" (click)="onSave()">Save Event & Exit</button>
        </div>
      </div>
    </div>
    <mdb-tabs #tabs class="mdb-tabs" (activeTabChange)="onTabChange($event)">
      <mdb-tab title="Virtual Event">
        <div class="background__color--white py-4">
          <div class="container">
            <div class="card__header">
              <div class="card__title">General Information</div>
            </div>
            <div class="row">
              <div class="col-4">
                <div class="position-relative w-100">
                  <div
                    *ngIf="form.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                    style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                    class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                  >
                    <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageFile"></app-input-file>
                  </div>
                  <div
                    *ngIf="form.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                    style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                    class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                  >
                    <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetImage()"></app-icon-delete>
                  </div>
                  <img style="border-radius: 5px" class="w-100" [src]="form.controls.imageDataUrl.value">
                </div>
              </div>
            </div>
            <div class="row mb-4 mt-1">
              <div class="col-4 text-center">
                  @if(form.controls.imageDataUrl.value === '/images/blank_2x1.png'){
                    <span class="d-block blue-text body-2 text-center">OR</span>
                    <a (click)="openChooseImageModal(0)" class="blue-text body-2">Choose from previously used images</a>
                }
              </div>
            </div>
            <mdb-form-control class="form-fill">
              <app-mdbp-input mdbInput formControlName="name" label='Event Name'></app-mdbp-input>
              <span class="form-fill-error"  *ngIf="form.controls.name.hasError('required') && form.controls.name.touched ">Please provide Virtual Event Name</span>
            </mdb-form-control>
            <div class="position-relative mb-4">
              <label class="form-check-label form-check-label--paybee mb-1">Event description</label>
              <mdb-form-control class="mb-4">
                <app-quill-custom mdbInput formControlName="desc" limit="2048"></app-quill-custom>
              </mdb-form-control> 
            </div>
            <div class="row justify-content-left">
              <div class="col">
                <mdb-form-control class="form-fill">
                  <mdb-select formControlName="eventType" class="mdb-select">
                    <mdb-option *ngFor="let virtualEventType of virtualEventTypeService.list" [value]="virtualEventType.value">{{
                      virtualEventType.label
                    }}</mdb-option>
                  </mdb-select>
                  <label mdbLabel class="form-label form-label--paybee">Virtual Event Type</label>
                </mdb-form-control>
              </div>
            </div>
            <div class="row justify-content-left">
              <div class="col">
                <app-datetime
                  dateLabel="Event Date"
                  timeLabel="Event Time"
                  [timezone]="form.controls.timeZoneData.value.name"
                  formControlName="startDateTimeGmtUnix"
                  [required]="true"
                  [submitted]="submitted"
                  data-panel="info"
                ></app-datetime>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <mdb-form-control class="form-fill">
                  <app-mdbp-input mdbInput formControlName="duration" [isCurrencyMask]="true" label='Duration in minutes'>
                    <input  #inputNameC currencyMask [options]="{ allowNegative: false, prefix: '', inputMode: 1 }" formControlName="duration" class="form-control form-control--paybee"/>
                  </app-mdbp-input>
                  <span class="form-fill-error"  *ngIf="form.controls.duration.hasError('required') && form.controls.duration.touched ">Please provide Virtual Event Duration</span>
                  <span class="form-fill-error"  *ngIf="form.controls.duration.hasError('min') && form.controls.duration.touched ">Duration should not be less than 1 min</span>
              </mdb-form-control>
              </div>
              <div class="col-6" formGroupName="timeZoneData">
                <mdb-form-control class="form-fill">
                  <mdb-select formControlName="name" class="mdb-select" [filter]="true">
                    <mdb-option *ngFor="let timeZone of timeZoneService.list" [value]="timeZone.value">{{
                      timeZone.label
                    }}</mdb-option>
                  </mdb-select>
                  <label mdbLabel class="form-label form-label--paybee">Time Zone</label>
                </mdb-form-control>
              </div>
            </div>
            <mdb-accordion [multiple]="true">

              <mdb-accordion-item [collapsed]="!accordion.stream.expanded" (itemShown)="onAfterExpand('stream')" (itemHidden)="onAfterCollapse('stream')">
                <ng-template mdbAccordionItemHeader>  Live Stream Info</ng-template>
                <ng-template mdbAccordionItemBody>
                  <div class="row justify-content-left">
                    <div class="col">
                      <mdb-form-control class="form-fill">
                        <mdb-select formControlName="streamProvider" (valueChange)="onChangeProvider($event)" class="mdb-select" data-panel="stream">
                          <mdb-option *ngFor="let streamProvider of streamProviderService.list" [value]="streamProvider.value" [disabled]="streamProvider.value === 4 &&(user && !user.payBeeStreamingEnabled)">{{
                            streamProvider.label
                          }}
                          <span class="stream-disabled stream-select-detail-info" *ngIf="streamProvider.value === 4 && (user && !user.payBeeStreamingEnabled)" >
                            (PayBee low latency is in limited availability now, please contact us if you would like to use it for your hybrid or virtual event)
                          </span>
                        </mdb-option>
                        </mdb-select>
                        <label mdbLabel class="form-label form-label--paybee">Stream Provider</label>
                      </mdb-form-control>
                    </div>
                </div>
                <div *ngIf="selectedProvider !== 4 else paybeeStream" class="row justify-content-left">
                    <div class="col">
                        <mdb-form-control class="form-fill">
                          <app-mdbp-input mdbInput maxLength="512" formControlName="streamUrl" label='Stream Url'></app-mdbp-input>
                        </mdb-form-control>
                    </div>
                </div>
                  <ng-template #paybeeStream>
                  <ng-container *ngIf="paybeeStreamInfo && user && user.payBeeStreamingEnabled">
                    <div class="stream-info">
                      <div class="line">
                        <span>Playback Url: </span>
                        <span
                          class="copy-button"
                          (click)="onLiveStreamPreview($event)"
                        >
                          <i class="fa-regular fa-video"></i>
                          <span> Preview </span>
                        </span>
                        <span
                          id="cp-1"
                          class="copy-button"
                          [cdkCopyToClipboard]="getText(paybeeStreamInfo.playBackUrl)"
                          (click)="onCopyToClipboard($event, 'cp-1', 'Copy Url')"
                        >
                          <i class="far fa-copy mr-2"></i>
                          <span>Copy Url </span>
                        </span>
                      </div>
                      <div class="line">
                        <span>RTMP Url: </span> {{ paybeeStreamInfo.rtmpUrl }}
                        <span
                          id="cl-1"
                          class="copy-button"
                          [cdkCopyToClipboard]="getText(paybeeStreamInfo.rtmpUrl)"
                          (click)="onCopyToClipboard($event, 'cl-1', 'Copy URL')"
                        >
                          <i class="far fa-copy mr-2"></i>
                          <span>Copy URL </span>
                        </span>
                      </div>

                      <div class="line">
                        <span>Stream key: </span> {{ paybeeStreamInfo.streamKey }}
                        <span
                          id="ck-1"
                          class="copy-button"
                          [cdkCopyToClipboard]="getText(paybeeStreamInfo.streamKey)"
                          (click)="onCopyToClipboard($event, 'ck-1', 'Copy Key')"
                          >
                          <i class="far fa-copy mr-2"></i>
                          <span>Copy Key </span>
                        </span>
                      </div>
                    </div>

                    <div class="stream-help">
                      <a (click)="onClickStreamInfo()">
                        <i class="blue-text far fa-question-circle" aria-hidden="true"></i>
                        <small class="blue-text"> How to configure stream properly </small>
                      </a>
                    </div>

                  </ng-container>
                </ng-template>

                </ng-template>
              </mdb-accordion-item>

              <mdb-accordion-item [collapsed]="!accordion.settings.expanded" (itemShown)="onAfterExpand('settings')" (itemHidden)="onAfterCollapse('settings')">
                <ng-template mdbAccordionItemHeader>Event Settings</ng-template>
                <ng-template mdbAccordionItemBody>

                <app-mdb-switch label="Guest will be asked for Street Address" formControlName="donorStreetAddressNeeded"></app-mdb-switch>

                <app-mdb-switch label="Guest will be asked for phone number" formControlName="donorPhoneNeeded"></app-mdb-switch>

                <app-mdb-switch label="Show pledge progress against goal to attendees" formControlName="showGoalToDonors"></app-mdb-switch>

                <div class="row justify-content-left">
                    <div class="col">

                        <mdb-form-control class="form-fill">
                          <app-mdbp-input mdbInput formControlName="goal" [isCurrencyMask]="true" label='Goal'>
                              <input  #inputNameC currencyMask formControlName="goal" class="form-control form-control--paybee"/>
                          </app-mdbp-input>
                        </mdb-form-control>
                    </div>
                </div>

                <app-mdb-switch label="Hide option for the donors to cover transaction fee" formControlName="hideDonorFee"></app-mdb-switch>

                <app-mdb-switch label="Ask donors for additional information" formControlName="additionalInfoRequired"></app-mdb-switch>

                <div style="padding-left: 44px;" *ngIf="form.value.additionalInfoRequired">


                    <mdb-form-control class="form-fill">
                      <app-mdbp-input mdbInput formControlName="additionalInfoName" label='Additional Info Name' data-panel="settings"></app-mdbp-input>
                      <span class="form-fill-error"  *ngIf="form.controls.additionalInfoName.hasError('required') && form.controls.additionalInfoName.touched ">Please provide Additional Info Name</span>
                    </mdb-form-control>
                </div>
                <div class="row">
                    <div class="col-8 d-flex">

                        <app-mdb-switch label="Allow donors to donate anonymously" formControlName="showAnonymous"></app-mdb-switch>

                          <div class="d-flex align-items-center ml-2 h-100">
                            <app-text-popover
                              type="content"
                              text="If selected allows donors to select being anonymous when they join the event. If the donor selects this option, other participants will not see the donor's name when shown in the activity list. Only applicable for donations, not for live auction or last hero game."
                            >
                            </app-text-popover>
                        </div>
                    </div>
                </div>

                <app-mdb-switch label="Show donate button" formControlName="defaultDonateCampaignRequired"></app-mdb-switch>

                <div style="padding-left: 44px;" *ngIf="form.value.defaultDonateCampaignRequired">
                  <ng-container *ngIf="donationCampaigns$ | async as campaigns">
                    <ng-container *ngIf="campaigns.length; else noCampaigns">
                      <mdb-form-control class="form-fill">
                        <mdb-select formControlName="defaultDonateCampaignId" class="mdb-select" [filter]="true">
                          <mdb-option *ngFor="let campaign of campaigns" [value]="campaign.id">{{
                            campaign.name
                            }}</mdb-option>
                        </mdb-select>
                        <label mdbLabel class="form-label form-label--paybee">Select Campaign</label>
                        <span class="form-fill-error"  *ngIf="form.controls.defaultDonateCampaignId.hasError('required') && form.controls.defaultDonateCampaignId.touched">Select a Donation campaign</span>
                      </mdb-form-control>
                    </ng-container>
                    <ng-template #noCampaigns>
                      <div class="no-campaigns">There are no active Donation Campaigns. Please create new Donation Campaign on Campaign Management </div>
                    </ng-template>
                  </ng-container>
                </div>

                <div class="row justify-content-left">
                    <div class="col">

                        <mdb-form-control class="form-fill">
                          <mdb-select formControlName="pledgeBehaviour" class="mdb-select">
                            <mdb-option *ngFor="let pledgeBehaviour of pledgeBehaviourService.list" [value]="pledgeBehaviour.value">{{
                              pledgeBehaviour.label
                            }}</mdb-option>
                          </mdb-select>
                          <label mdbLabel class="form-label form-label--paybee">Pledge Behaviour</label>
                        </mdb-form-control>
                    </div>
                </div>

                <div class="row">
                  <div class="col-12 d-flex">
                    <app-mdb-switch label="Show Banner" formControlName="showBanner"></app-mdb-switch>
                  </div>

                  <div class="col-12 mb-5" style="padding-left: 44px;" *ngIf="form.value.showBanner">

                      <label class="form-check-label form-check-label--paybee mb-1"> Banner Description </label>
                      <mdb-form-control class="mb-4">
                        <app-quill-custom mdbInput formControlName="bannerDesc" limit="512"></app-quill-custom>
                      </mdb-form-control> 
                  </div>
                </div>

                </ng-template>
              </mdb-accordion-item>

              <mdb-accordion-item [collapsed]="!accordion.music.expanded" (itemShown)="onAfterExpand('music')" (itemHidden)="onAfterCollapse('music')">
                <ng-template mdbAccordionItemHeader> Music</ng-template>
                <ng-template mdbAccordionItemBody>
                  <div class="small text-muted">Lobby Music</div>
                  <div class="row align-items-center">
                      <div class="col-4" id="lobbyMusicCol"><audio id="lobbyMusicAudio" controls="" loop="" style="outline: none;"><source [src]="form.value.lobbyMusic"></audio></div>
                      <div class="col-2">
                          <div class="file-field">
                              <div class="d-flex justify-content-end">
                                  <div (click)="onChangeMusic('lobby')" id="changeLobbyMusic" class="btn btn-flat waves-effect waves-effect" style="margin-left: 0px; padding-left: 0px; padding-top: 0px;">
                                      <span class="blue-text">Change</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-2">
                          <div class="file-field">
                              <div class="d-flex justify-content-end">
                                  <div (click)="onResetMusic('lobby')" id="resetLobbyMusic" class="btn btn-flat waves-effect waves-effect" style="margin-left: 0px; padding-left: 0px; padding-top: 0px;">
                                      <span class="red-text">Reset</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="small mt-3 text-muted">End Music</div>
                  <div class="row align-items-center">
                      <div class="col-4" id="endMusicCol"><audio id="endMusicAudio" controls="" loop="" style="outline: none;"><source [src]="form.value.endMusic"></audio></div>
                      <div class="col-2">
                          <div class="file-field">
                              <div class="d-flex justify-content-end">
                                  <div (click)="onChangeMusic('end')" id="changeEndMusic" class="btn btn-flat waves-effect waves-effect" style="margin-left: 0px; padding-left: 0px; padding-top: 0px;">
                                      <span class="blue-text">Change</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div class="col-2">
                          <div class="file-field">
                              <div class="d-flex justify-content-end">
                                  <div (click)="onResetMusic('end')" id="resetEndMusic" class="btn btn-flat waves-effect waves-effect" style="margin-left: 0px; padding-left: 0px; padding-top: 0px;">
                                      <span class="red-text">Reset</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>

                </ng-template>
              </mdb-accordion-item>

            </mdb-accordion>
          </div>
        </div>
      </mdb-tab>
      <mdb-tab title="Lobby Slides">
        <div class="background__color--white py-4">
          <div class="container">
            <div class="card__header mb-3">
              <div class="row w-100">
                <div class="col-12 d-flex justify-content-between">
                  <div class="card__left-side card__title d-flex">
                    <span class="d-flex align-items-center mr-2">Slides</span>
                    <button class="btn btn--paybee btn-sm modal-confirm-button mr-2" (click)="onChangeSlideMode('editor')">+ Add</button>
                  </div>

                </div>
              </div>
            </div>
            <div class="card__content">
              <app-virtual-event-slide-list
                [form]="form"
              ></app-virtual-event-slide-list>
            </div>
            <div class="drag-and-drop d-flex align-items-center justify-content-center mt-3">Drag and drop slides to reorder or use Move.</div>
          </div>
      </div>
      </mdb-tab>
      <mdb-tab title="Sponsors">
              <div class="background__color--white py-4">
          <div class="container">
            <div class="card__header mb-3">
              <div class="row w-100">
                <div class="col-12 d-flex justify-content-between">
                  <div class="card__left-side card__title d-flex">
                    <span class="d-flex align-items-center mr-2">Sponsors</span>
                    <button class="btn btn--paybee btn-sm modal-confirm-button mr-2" (click)="onChangeSponsorMode('editor')">+ Add</button>
                  </div>
                </div>
              </div>
            </div>
            <div class="card__content">
              <app-virtual-event-sponsor-list
                [form]="form"
                (onEditSponsor)="editSponsor($event)"
              ></app-virtual-event-sponsor-list>
            </div>
            <div class="drag-and-drop d-flex align-items-center justify-content-center mt-3">Drag and drop sponsors to reorder or use Move.</div>
          </div>
        </div>
      </mdb-tab>
      <mdb-tab title="Event Page">
          <div class="background__color--white py-4">
              <div class="container">
                <div class="card__header mb-4">
                        <app-event-configuration-list
                          [eventPageId]="eventPageId"
                          (onUpdatePage)="updateEventPage($event)"
                          (themeConfigurationScreenStatus)="onShowThemeConfiguration($event)"
                          (onChangeEventConfigMode)="changeEventConfigMode($event)"
                        >
                        </app-event-configuration-list>
                </div>
              </div>
            </div>
      </mdb-tab>
    </mdb-tabs>

  </ng-container>

  <ng-container *ngIf="sponsorMode === 'editor'">
    <div class="container py-3">
        <div class="d-flex justify-content-between">
            <div class="campaign-option__back d-flex align-items-center">
                <div class="campaign-option__arrow--back mr-2">
                  <svg width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>Path</title>
                    <defs>
                        <filter id="filter-1">
                            <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                        </filter>
                    </defs>
                    <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.327584403">
                        <g id="New-Option-Header" transform="translate(-25.000000, -31.000000)">
                            <g id="Header" transform="translate(25.000000, 29.000000)">
                                <g id="Group">
                                    <g filter="url(#filter-1)" id="Title-2">
                                        <g>
                                            <path d="M14,7.9082345 C14,7.40965047 13.5958178,7.00546826 13.0972338,7.00546826 L3.19614499,7.00546826 L6.86588976,3.5839842 C7.11510392,3.36724892 7.22607028,3.03172226 7.15522243,2.70913513 C7.08437457,2.38654799 6.84302279,2.12839883 6.52592404,2.03603942 C6.20882529,1.94368 5.86660186,2.03185477 5.63361384,2.26594548 L0.286980768,7.24695823 C0.103934415,7.41770376 0,7.65678625 0,7.90710605 C0,8.15742585 0.103934415,8.39650834 0.286980768,8.56725386 L5.63361384,13.5505235 C5.99820341,13.8908071 6.56961602,13.8711032 6.90989962,13.5065137 C7.25018322,13.1419241 7.23047934,12.5705115 6.86588976,12.2302279 L3.19614499,8.81100075 L13.0972338,8.81100075 C13.5958178,8.81100075 14,8.40681853 14,7.9082345 Z" id="Path" fill="#B3B3B3" fill-rule="nonzero"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                  </svg>
                </div>
                <div class="campaign-option__campaign-name">Back</div>
            </div>
            <div class="d-flex justify-content-end">
                <div class="campaign__action-list d-flex align-items-center">
                  <button class="btn btn--paybee btn--outline-transparent mr-2" (click)="onChangeSponsorMode('list')">Cancel</button>
                  <button [ngClass]="imageService.loadingClasses()" class="btn btn--paybee btn--black" (click)="onSaveSponsor()">Save Sponsor</button>
                </div>
            </div>
        </div>
      </div>
      <div class="background__color--white py-4">
        <div class="container">
          <div class="card__content" [formGroup]="virtualEventSponsor">
            <div class="card__header">
                <div class="card__title">Sponsor</div>
            </div>
            <div class="row">
              <div class="col-4">
                  <div class="position-relative w-100">
                      <div
                          *ngIf="virtualEventSponsor.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                          style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                          class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                      >
                          <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageFile"></app-input-file>
                      </div>
                      <div
                          *ngIf="virtualEventSponsor.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                          style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                          class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                      >
                          <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetSponsorImage()"></app-icon-delete>
                      </div>
                      <img style="border-radius: 5px" class="w-100" [src]="virtualEventSponsor.controls.imageDataUrl.value">
                  </div>
                  <div *ngIf="virtualEventSponsor.controls.imageUrl.touched"  class="mat-form-field-description pb-3 text-center">
                    <div class="mat-error">{{ getSponsorImageErrorMessage() }}</div>
                  </div>
              </div>
            </div>
            <div class="row mb-4 mt-1">
              <div class="col-4 text-center">
                  @if(virtualEventSponsor.controls.imageDataUrl.value === '/images/blank_2x1.png'){
                    <span class="d-block blue-text body-2 text-center">OR</span>
                    <a (click)="openChooseImageModal(0, 'sponsor')" class="blue-text body-2">Choose from previously used images</a>
                }
              </div>
            </div>

            <mdb-form-control class="form-fill">
              <app-mdbp-input mdbInput formControlName="name" label='Sponsor Name'></app-mdbp-input>
              <span class="form-fill-error"  *ngIf="virtualEventSponsor.controls.name.hasError('required') && virtualEventSponsor.controls.name.touched ">Please provide Sponsor Name</span>
            </mdb-form-control>

            <mdb-form-control class="form-fill">
              <app-mdbp-input mdbInput formControlName="sponsorUrl" label='Sponsor Url'></app-mdbp-input>
              <span class="form-fill-error"  *ngIf="virtualEventSponsor.controls.sponsorUrl.hasError('pattern') && virtualEventSponsor.controls.sponsorUrl.touched">Incorrect format of Sponsor URL</span>
              <span class="form-fill-error"  *ngIf="virtualEventSponsor.controls.sponsorUrl.hasError('url') && virtualEventSponsor.controls.sponsorUrl.touched">Incorrect format of Sponsor URL</span>
            </mdb-form-control>
          </div>
        </div>
    </div>
  </ng-container>

  <ng-container *ngIf="slideMode === 'editor'">
    <div class="container py-3">
        <div class="d-flex justify-content-between">
            <div class="campaign-option__back d-flex align-items-center">
                <div class="campaign-option__arrow--back mr-2">
                  <svg width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <title>Path</title>
                    <defs>
                        <filter id="filter-1">
                            <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                        </filter>
                    </defs>
                    <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.327584403">
                        <g id="New-Option-Header" transform="translate(-25.000000, -31.000000)">
                            <g id="Header" transform="translate(25.000000, 29.000000)">
                                <g id="Group">
                                    <g filter="url(#filter-1)" id="Title-2">
                                        <g>
                                            <path d="M14,7.9082345 C14,7.40965047 13.5958178,7.00546826 13.0972338,7.00546826 L3.19614499,7.00546826 L6.86588976,3.5839842 C7.11510392,3.36724892 7.22607028,3.03172226 7.15522243,2.70913513 C7.08437457,2.38654799 6.84302279,2.12839883 6.52592404,2.03603942 C6.20882529,1.94368 5.86660186,2.03185477 5.63361384,2.26594548 L0.286980768,7.24695823 C0.103934415,7.41770376 0,7.65678625 0,7.90710605 C0,8.15742585 0.103934415,8.39650834 0.286980768,8.56725386 L5.63361384,13.5505235 C5.99820341,13.8908071 6.56961602,13.8711032 6.90989962,13.5065137 C7.25018322,13.1419241 7.23047934,12.5705115 6.86588976,12.2302279 L3.19614499,8.81100075 L13.0972338,8.81100075 C13.5958178,8.81100075 14,8.40681853 14,7.9082345 Z" id="Path" fill="#B3B3B3" fill-rule="nonzero"></path>
                                        </g>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                  </svg>
                </div>
                <div class="campaign-option__campaign-name">Back</div>
            </div>
            <div class="d-flex justify-content-end">
                <div class="campaign__action-list d-flex align-items-center">
                  <button class="btn btn--paybee btn--outline-transparent mr-2" (click)="onChangeSlideMode('list')">Cancel</button>
                  <button class="btn btn--paybee btn--black" (click)="onSaveSlide()">Save Slide</button>
                </div>
            </div>
        </div>
      </div>
      <div class="background__color--white py-4">
        <div class="container">
          <div class="card__content" [formGroup]="virtualEventSlide">
            <div class="card__header">
                <div class="card__title">Slide</div>
            </div>
            <div class="row">
                <div class="col-4">
                    <div class="position-relative w-100">

                        <div
                            *ngIf="virtualEventSlide.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                            style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                            class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                        >
                            <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageFile"></app-input-file>
                        </div>
                        <div
                            *ngIf="virtualEventSlide.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                            style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                            class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                        >
                            <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetSlideImage()"></app-icon-delete>
                        </div>
                        <img style="border-radius: 5px" class="w-100" [src]="virtualEventSlide.controls.imageDataUrl.value">
                    </div>
                    <div *ngIf="virtualEventSlide.controls.imageDataUrl.touched" class="mat-form-field-description pb-3 text-center">
                      <div class="mat-error">{{ getSlideImageErrorMessage() }}</div>
                    </div>
                </div>
            </div>

            <div class="row mb-4 mt-1">
              <div class="col-4 text-center">
                  @if(virtualEventSlide.controls.imageDataUrl.value === '/images/blank_2x1.png'){
                    <span class="d-block blue-text body-2 text-center">OR</span>
                    <a (click)="openChooseImageModal(0, 'lobbySlides')" class="blue-text body-2">Choose from previously used images</a>
                }
              </div>
            </div>

            <mdb-form-control class="form-fill">
              <app-mdbp-input mdbInput formControlName="name" label='Slide Name'></app-mdbp-input>
              <span class="form-fill-error"  *ngIf="virtualEventSlide.controls.name.hasError('required') && virtualEventSlide.controls.name.touched ">Please provide Slide Name</span>
            </mdb-form-control>
          </div>
        </div>
    </div>
  </ng-container>

  <ng-container *ngIf="eventPageSlideMode === 'editor'">
    <div class="container py-3">
      <div class="d-flex justify-content-between">
        <div class="campaign-option__back d-flex align-items-center">
          <div class="campaign-option__arrow--back mr-2">
            <svg width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>Path</title>
              <defs>
                <filter id="filter-1">
                  <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                </filter>
              </defs>
              <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.327584403">
                <g id="New-Option-Header" transform="translate(-25.000000, -31.000000)">
                  <g id="Header" transform="translate(25.000000, 29.000000)">
                    <g id="Group">
                      <g filter="url(#filter-1)" id="Title-2">
                        <g>
                          <path d="M14,7.9082345 C14,7.40965047 13.5958178,7.00546826 13.0972338,7.00546826 L3.19614499,7.00546826 L6.86588976,3.5839842 C7.11510392,3.36724892 7.22607028,3.03172226 7.15522243,2.70913513 C7.08437457,2.38654799 6.84302279,2.12839883 6.52592404,2.03603942 C6.20882529,1.94368 5.86660186,2.03185477 5.63361384,2.26594548 L0.286980768,7.24695823 C0.103934415,7.41770376 0,7.65678625 0,7.90710605 C0,8.15742585 0.103934415,8.39650834 0.286980768,8.56725386 L5.63361384,13.5505235 C5.99820341,13.8908071 6.56961602,13.8711032 6.90989962,13.5065137 C7.25018322,13.1419241 7.23047934,12.5705115 6.86588976,12.2302279 L3.19614499,8.81100075 L13.0972338,8.81100075 C13.5958178,8.81100075 14,8.40681853 14,7.9082345 Z" id="Path" fill="#B3B3B3" fill-rule="nonzero"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="campaign-option__campaign-name">Back</div>
        </div>
        <div class="d-flex justify-content-end">
          <div class="campaign__action-list d-flex align-items-center">
            <button class="btn btn--paybee btn--outline-transparent mr-2" (click)="onChangeEventPageSlideMode('list')">Cancel</button>
            <button class="btn btn--paybee btn--black" (click)="onSaveEPSlide()">Save Slide</button>
          </div>
        </div>
      </div>
    </div>
    <div class="background__color--white py-4">
      <div class="container">
        <div class="card__content" [formGroup]="eventPageSlide">
          <div class="card__header">
            <div class="card__title">Slide</div>
          </div>
          <div class="row">
            <div class="col-4">
              <div class="position-relative w-100">
                <div
                  *ngIf="eventPageSlide.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                  style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                  class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                >
                  <app-input-file class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageFile"></app-input-file>
                </div>
                <div
                  *ngIf="eventPageSlide.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                  style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                  class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                >
                  <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetEventPageSlideImage()"></app-icon-delete>
                </div>
                <img style="border-radius: 5px" class="w-100" [src]="eventPageSlide.controls.imageDataUrl.value">
              </div>
            </div>
          </div>

          <div class="row mb-4 mt-1">
            <div class="col-4 text-center">
                @if(eventPageSlide.controls.imageDataUrl.value === '/images/blank_2x1.png'){
                  <span class="d-block blue-text body-2 text-center">OR</span>
                  <a (click)="openChooseImageModal(0, 'eventPageSlides')" class="blue-text body-2">Choose from previously used images</a>
              }
            </div>
          </div>

          <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput formControlName="name" label='Slide Name'></app-mdbp-input>
            <span class="form-fill-error"  *ngIf="eventPageSlide.controls.name.hasError('required') && eventPageSlide.controls.name.touched ">Please provide Slide Name</span>
          </mdb-form-control>
        </div>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="configMode === 'eventConfig'">
    <div class="container py-3">
      <div class="d-flex justify-content-between">
        <div class="campaign-option__back d-flex align-items-center">
          <div class="campaign-option__arrow--back mr-2">
            <svg width="14px" height="12px" viewBox="0 0 14 12" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <title>Path</title>
              <defs>
                <filter id="filter-1">
                  <feColorMatrix in="SourceGraphic" type="matrix" values="0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 0 0.000000 0 0 0 1.000000 0"></feColorMatrix>
                </filter>
              </defs>
              <g id="New-Compaign" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.327584403">
                <g id="New-Option-Header" transform="translate(-25.000000, -31.000000)">
                  <g id="Header" transform="translate(25.000000, 29.000000)">
                    <g id="Group">
                      <g filter="url(#filter-1)" id="Title-2">
                        <g>
                          <path d="M14,7.9082345 C14,7.40965047 13.5958178,7.00546826 13.0972338,7.00546826 L3.19614499,7.00546826 L6.86588976,3.5839842 C7.11510392,3.36724892 7.22607028,3.03172226 7.15522243,2.70913513 C7.08437457,2.38654799 6.84302279,2.12839883 6.52592404,2.03603942 C6.20882529,1.94368 5.86660186,2.03185477 5.63361384,2.26594548 L0.286980768,7.24695823 C0.103934415,7.41770376 0,7.65678625 0,7.90710605 C0,8.15742585 0.103934415,8.39650834 0.286980768,8.56725386 L5.63361384,13.5505235 C5.99820341,13.8908071 6.56961602,13.8711032 6.90989962,13.5065137 C7.25018322,13.1419241 7.23047934,12.5705115 6.86588976,12.2302279 L3.19614499,8.81100075 L13.0972338,8.81100075 C13.5958178,8.81100075 14,8.40681853 14,7.9082345 Z" id="Path" fill="#B3B3B3" fill-rule="nonzero"></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </g>
            </svg>
          </div>
          <div class="campaign-option__campaign-name">Back</div>
        </div>
        <div class="d-flex justify-content-end">
          <div class="campaign__action-list d-flex align-items-center">
            <button class="btn btn--paybee btn--outline-transparent mr-2" (click)="moveToEventPageList( 'list')">Cancel</button>
            <button class="btn btn--paybee btn--black" (click)="onSaveEventPageBlock()">Save Section</button>
          </div>
        </div>
      </div>
    </div>
    <div class="background__color--white py-4">
      <div class="container">

        <div class="row justify-content-left">
          <div class="col" [formGroup]="eventConfiguration" >
            <mdb-form-control class="form-fill">
              <mdb-select formControlName="eventPageBlockType" [disabled]="disableTypeSelect" [(ngModel)]="selectedPageType" optionHeight='48' class="mdb-select page-type" data-panel="stream">
                <mdb-option *ngFor="let eventBlockType of eventPageBlockTypeService.list" [value]="eventBlockType.id">{{
                  eventBlockType.label
                }}</mdb-option>
              </mdb-select>
              <label mdbLabel class="form-label form-label--paybee">Event Page Section Type</label>
            </mdb-form-control>
          </div>
        </div>

        <div [formGroup]="textPart"  *ngIf="selectedPageType == 1">
          <app-mdb-switch label="Remove this section from top menu" formControlName="removeFromNav"></app-mdb-switch>
          <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput formControlName="textBlockTitle" label='Please provide text block title'></app-mdbp-input>
            <span class="form-fill-error"  *ngIf="textPart.controls.textBlockTitle.hasError('required') && textPart.controls.textBlockTitle.touched ">Please provide Slide Name</span>
          </mdb-form-control>
        <div class="position-relative mb-4">
          <label class="form-check-label form-check-label--paybee mb-1">Text block</label>
          <mdb-form-control class="mb-4">
            <app-quill-custom mdbInput formControlName="textBlock" limit="1024"></app-quill-custom>
          </mdb-form-control> 
        </div>
        </div>

        <div [formGroup]="faqPart"   *ngIf="selectedPageType == 2">
          <app-mdb-switch label="Remove this section from top menu" formControlName="removeFromNav"></app-mdb-switch>
           <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput formControlName="faqBlockTitle" label='Please provide FAQ block title '></app-mdbp-input>
            <span class="form-fill-error"  *ngIf="faqPart.controls.faqBlockTitle.hasError('required') && faqPart.controls.faqBlockTitle.touched ">Please provide FAQ Section Name</span>
          </mdb-form-control>
          <app-faq-list [faqForm]="faqPart"></app-faq-list>
        </div>

        <div [formGroup]="slidesPart"   *ngIf="selectedPageType == 3">
          <app-mdb-switch label="Remove this section from top menu" formControlName="removeFromNav"></app-mdb-switch>
          <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput formControlName="slidesBlockTitle" label='Please provide Slides block title '></app-mdbp-input>
            <span class="form-fill-error"  *ngIf="slidesPart.controls.slidesBlockTitle.hasError('required') && slidesPart.controls.slidesBlockTitle.touched ">Please provide Slides Section Name</span>
          </mdb-form-control>

          <div class="d-flex">
            <button class="btn btn--paybee btn-sm modal-confirm-button mr-2" (click)="onChangeEventPageSlideMode('editor')">+ Add new Slide</button>
            <app-input-file accept="image/png,image/jpeg" multiple="true" label="Bulk Import" [formControl]="slidesPartBulkImport"></app-input-file>
          </div>
          
          <app-event-page-slides-list [slideForm]="slidesPart"></app-event-page-slides-list>
        </div>

        <div [formGroup]="donationCampaignPart"   *ngIf="selectedPageType == 4">
          <app-mdb-switch label="Remove this section from top menu" formControlName="removeFromNav"></app-mdb-switch>
          <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput formControlName="title" label='Please provide campaign title '></app-mdbp-input>
          </mdb-form-control>

          <div class="col-12 px-0">
            <ng-container *ngIf="campaigns$ | async as campaigns">
              <mdb-form-control class="form-fill w-100">
                <mdb-select formControlName="campaignId" class="mdb-select" data-panel="settings" [filter]="true">
                  <mdb-option *ngFor="let campaign of campaigns" [value]="campaign.id">
                    {{ campaign.name }}
                  </mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label form-label--paybee">Select Campaign</label>
                <span class="form-fill-error"  *ngIf="donationCampaignPart.controls.campaignId.hasError('required') && donationCampaignPart.controls.campaignId.touched">Please provide Campaign</span>
              </mdb-form-control>
            </ng-container>
          </div>
        </div>

        <div [formGroup]="silentAuctionCampaignPart"   *ngIf="selectedPageType == 5">
          <app-mdb-switch label="Remove this section from top menu" formControlName="removeFromNav"></app-mdb-switch>
          <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput formControlName="title" label='Please provide title for silent auction'></app-mdbp-input>
          </mdb-form-control>

          <div class="col-12 px-0">
            <ng-container *ngIf="silentAuctions$ | async as silentAuctions">
              <mdb-form-control class="form-fill w-100">
                <mdb-select formControlName="campaignId" class="mdb-select" data-panel="settings" [filter]="true">
                  <mdb-option *ngFor="let auction of silentAuctions" [value]="auction.id">{{
                    auction.name
                  }}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label form-label--paybee">Select Campaign</label>
                <span class="form-fill-error"  *ngIf="silentAuctionCampaignPart.controls.campaignId.hasError('required') && silentAuctionCampaignPart.controls.campaignId.touched">Please provide Auction Campaign</span>
              </mdb-form-control>
            </ng-container>
          </div>
        </div>

        <div [formGroup]="liveAuctionCampaignPart"   *ngIf="selectedPageType == 6">
          <app-mdb-switch label="Remove this section from top menu" formControlName="removeFromNav"></app-mdb-switch>
          <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput formControlName="title" label='Please provide title for live auction '></app-mdbp-input>
          </mdb-form-control>
          <div class="col-12 px-0">
            <ng-container *ngIf="liveAuctions$ | async as liveAuctions">
              <mdb-form-control class="form-fill w-100" data-panel="settings">
                <mdb-select formControlName="campaignId" class="mdb-select" data-panel="settings" [filter]="true">
                  <mdb-option *ngFor="let auction of liveAuctions" [value]="auction.id">{{
                    auction.name
                  }}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label form-label--paybee">Select Campaign</label>
                <span class="form-fill-error"  *ngIf="liveAuctionCampaignPart.controls.campaignId.hasError('required') && liveAuctionCampaignPart.controls.campaignId.touched">Please provide Auction Campaign</span>
              </mdb-form-control>
            </ng-container>
          </div>
        </div>

        <div [formGroup]="videoContainerPart"  *ngIf="selectedPageType == 7">
          <app-mdb-switch label="Remove this section from top menu" formControlName="removeFromNav"></app-mdb-switch>
          <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput formControlName="videoContainerTitle" label='Please provide video container block title'></app-mdbp-input>
          </mdb-form-control>
        <div class="position-relative mb-4">
          <label class="form-check-label form-check-label--paybee mb-1">Video description</label>
          <mdb-form-control class="mb-4">
            <app-quill-custom mdbInput formControlName="videoContainerDesc" limit="1024"></app-quill-custom>
          </mdb-form-control> 
        </div>
          <div class="row justify-content-left">
            <div class="col">
              <mdb-form-control class="form-fill">
                <mdb-select formControlName="videoProvider" data-panel="stream" (valueChange)="resetVideoUrl()"  class="mdb-select" [(ngModel)]="videoProviderSelected">
                  <mdb-option *ngFor="let videoProvider of videoProviderService.list" [value]="videoProvider.value">{{
                    videoProvider.label
                  }}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label form-label--paybee">Please provide video Provider</label>
              </mdb-form-control>
            </div>
          </div>

          <ng-container *ngIf="videoProviderSelected === 0">
            <div class="video-help mb-2">
              <span>Please make sure that video url is embeddable on third party sites.</span>
            </div>
          </ng-container>

          <ng-container *ngIf="videoProviderSelected === 1">
            <div class="video-help">
             <div><strong>Finding the embed code on YouTube:</strong></div>
              <ol>
                <li>Go to YouTube.</li>
                <li>Navigate to the video you wish to embed.</li>
                <li>Click the Share link below the video, then click the Embed link.</li>
                <li>The embed link will be highlighted in blue. You will need to copy this link in order to add it to your page in the Employer Center.</li>
              </ol>
            </div>
          </ng-container>

          <ng-container *ngIf="videoProviderSelected === 2">
            <div class="video-help">
              <div><strong>Finding the embed code on Vimeo:</strong></div>
              <ol>
                <li>Go to Vimeo.</li>
                <li> Navigate to the video you wish to embed.</li>
                <li>Click the Share button, in the top right corner of your video.</li>
                <li>A pop-up will appear with the embed link information. You will need to copy only the src</li>
              </ol>
            </div>
          </ng-container>

          <ng-container *ngIf="videoProviderSelected === 3">
            <div class="video-help">
              <div><strong>Finding the embed code on Facebook:</strong></div>
              <ol>
                <li>Open Facebook on a computer.</li>
                <li>Go to the video you want to embed.</li>
                <li>Click and select Embed. Keep in mind that you will only see this option if the video's audience is set to Public.</li>
                <li>Copy link from the code that appears and paste it here.
              </ol>
            </div>
          </ng-container>

          <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput formControlName="videoContainerUrl" maxLength="512" label='Please provide video url'></app-mdbp-input>
            <span class="form-fill-error"  *ngIf="videoContainerPart.controls.videoContainerUrl.hasError('required') && videoContainerPart.controls.videoContainerUrl.touched ">Please provide Video Url</span>
          </mdb-form-control>
        </div>

        <div [formGroup]="imagePart" class="mb-2"  *ngIf="selectedPageType == 8">

          <app-mdb-switch label="Remove this section from top menu" formControlName="removeFromNav"></app-mdb-switch>
          <div class="row" >
            <div class="col-12 image-title">Event image: </div>
            <div class="col-4">
              <div class="position-relative w-100">
                <span class="form-fill-error" *ngIf="!eventImageSelected && imagePart.controls.imageFile.touched"><b>Please provide Image</b></span>
                <div
                  *ngIf="imagePart.controls.imageDataUrl.value === '/images/blank_2x1.png'"
                  style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                  class="d-flex align-items-center justify-content-center position-absolute h-100 w-100"
                >
                  <app-input-file (click)="eventImageSelected = true" class="position-absolute" accept="image/png,image/jpeg" label="Select Image" formControlName="imageFile"></app-input-file>
                </div>
                <div
                  *ngIf="imagePart.controls.imageDataUrl.value !== '/images/blank_2x1.png'"
                  style="border: 1px solid rgba(0, 0, 0, 0.07);border-radius: 5px;"
                  class="d-flex align-items-start justify-content-end position-absolute h-100 w-100"
                >
                  <app-icon-delete class="position-absolute" style="cursor:pointer; margin:8px;" (click)="resetImagePart()"></app-icon-delete>
                </div>
                <img style="border-radius: 5px" class="w-100" [src]="imagePart.controls.imageDataUrl.value">
                <span class="form-fill-error"  *ngIf="imagePart.controls.imageFile.hasError('required') && imagePart.controls.imageFile.touched ">Please provide Image</span>
              </div>
            </div>
          </div>

          <div class="row mb-4 mt-1">
            <div class="col-4 text-center">
              @if(imagePart.controls.imageDataUrl.value === '/images/blank_2x1.png'){
                <span class="d-block blue-text body-2 text-center">OR</span>
                <a (click)="openChooseImageModal(0, 'imageSection')" class="blue-text body-2">Choose from previously used images</a>
              }
            </div>
          </div>

          <mdb-form-control class="form-fill">
            <app-mdbp-input mdbInput formControlName="imageBlockTitle" label='Please provide Image block title'></app-mdbp-input>
            <span class="form-fill-error"  *ngIf="imagePart.controls.imageBlockTitle.hasError('required') && imagePart.controls.imageBlockTitle.touched ">Please provide Image Section Name</span>
          </mdb-form-control>

          <div class="position-relative mb-4">
            <label class="form-check-label form-check-label--paybee mb-1">Image Description</label>
            <mdb-form-control class="mb-4">
              <app-quill-custom mdbInput formControlName="imageBlockText" limit="1024"></app-quill-custom>
            </mdb-form-control> 
          </div>

        </div>

      </div>
    </div>
  </ng-container>
</ng-container>

